// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobsTable th {
    border-bottom: 1px solid black;
    text-align: left;
}

.JobsTable tr {
    height: 40px;
}

.placeHolder {
    width: 48px;
}`, "",{"version":3,"sources":["webpack://./src/app/settings/jobs/queue/jobs.queue.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".JobsTable th {\n    border-bottom: 1px solid black;\n    text-align: left;\n}\n\n.JobsTable tr {\n    height: 40px;\n}\n\n.placeHolder {\n    width: 48px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
